import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormspark } from "@formspark/use-formspark";
import ReCAPTCHA from "react-google-recaptcha";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box'
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete from '@mui/material/Autocomplete';
import { fade, makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import TimezoneSelect from 'react-timezone-select'

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

const email_regexp = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

const verifyEmail = (email) => {
  return email_regexp.test(email)
};

const notEmpty = (the_var) => {
  return the_var.length > 0;
};

const equalTo = (other) => {
  return (val) => {return val === other};
};

const ContactForm = () => {
  let history = useHistory();
  const [submit, submitting] = useFormspark({
    formId: process.env.REACT_APP_SPARKFORM_ID
  });


  const defaults = {
    "First Name": "",
    "Last Name": "",
    "Email": "",
    "Form Type": "Free Version"
  };


  const label_grouping = [
    {fields:  [
       "First Name",
       "Last Name",
       "Email",
       "ReCAPTCHA"
     ]
    }
  ]

  const labels = Object.keys(defaults);

  const [activeStep, setActiveStep] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState(defaults);
  const [recaptcha, setRecaptcha] = useState("");
  const [selectedTimezone, setSelectedTimezone] = useState('')

  const notEmptyTimezone = (the_var) => {
    return the_var = selectedTimezone;
  };

  const isRecaptchaSet = (the_var) => {
    return recaptcha && recaptcha.length > 0;
  }

  const verifiers = {
    "First Name": notEmpty,
    "Last Name": notEmpty,
    "Email": verifyEmail,
    "ReCAPTCHA": isRecaptchaSet
  }


  const getError = (label, the_var) => {
    //console.log(! ((verifiers[label] ? verifiers[label](the_var) : true)))
    return ! ((verifiers[label] ? verifiers[label](the_var) : true))
  }

  const verifyLabel = (label) => {
    let test = verifiers[label];
    return test ? test(message[label]) : true;
  }

  const checkAll = (fields) => {
    return fields.every(verifyLabel);
  }


  const handleNext = () => {
    setActiveStep(activeStep + 1)
  }

  const handleBack = () => {
    setActiveStep(activeStep - 1)
  }

  const handleSubmit = () => {
    submit({
      message,
      "g-recaptcha-response": recaptcha
    }).then((value) => {
      history.push('/FormSubmittedFree')
      // window.open('https://buy.stripe.com/test_fZe7wsfvY1k4cN2cMM','_blank').focus();
    }).catch((error) => {
      console.log(error)
    })
  }

  const getTextField = (label) => {
    return <div>
             <TextField
               fullWidth
               required={label in verifiers}
               id={label}
               error={message[label].length > 0 ? getError(label, message[label]) : false }
               label={label}
               value={message[label]}
               onChange={(e) => setMessage({...message, [label]: e.target.value})}
             />
           </div>
  };

  const getTimezoneField = (label) => {
      return (
      <div>
        <div className='select-wrapper'>
          <Box style={{ paddingTop:20 }}>
          <Typography variant="body3" style={{ fontFamily: 'Arial' }} align="left" color="textSecondary" component="p">
          Select timezone* (required for pipeline scheduling)
          </Typography>
          <TimezoneSelect
            fullWidth
            name="Select a timezone"
            required={label in verifiers}
            value={selectedTimezone}
            onChange={setSelectedTimezone}
          />
          </Box>
        </div>
      </div>
    )
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const getPasswordField = (label) => {
    return <div>
             <FormControl fullWidth>
               <InputLabel
                 htmlFor={label}
                 required={label in verifiers}
                 error={message[label].length > 0 ? getError(label, message[label]) : false }
               >{label}</InputLabel>
             <Input
               required={label in verifiers}
               id={label}
               error={message[label].length > 0 ? getError(label, message[label]) : false }
               label={label}
               value={message[label]}
               onChange={(e) => setMessage({...message, [label]: e.target.value})}
               type={showPassword ? 'text' : 'password'}
               endAdornment={
                 <InputAdornment position="end">
                   <IconButton
                     aria-label="toggle password visibility"
                     onClick={handleClickShowPassword}
                     onMouseDown={handleMouseDownPassword}
                   >
                     {showPassword ? <Visibility /> : <VisibilityOff />}
                   </IconButton>
                 </InputAdornment>
               }
             />
             </FormControl>
           </div>
  };

  const getRecaptcha = (label) => {
    return <Box
            style= {{ paddingTop: 20 }}>
            <ReCAPTCHA
             sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
             onChange={setRecaptcha}
            />
           </Box>
  };

  const default_field_type = getTextField;

  const field_types = {
    "Password": getPasswordField,
    "Timezone": getTimezoneField,
    "ReCAPTCHA": getRecaptcha
  };

  const getField = (label) => {
    return (field_types[label] || default_field_type)(label);
  }

  const getStepContent = (step) => {
    const page = label_grouping[step]
    if (submitting) {
      return <CircularProgress />
    }
    else {
      return <div>
               <h2>{page.header}</h2>
               {page.fields.map(getField)}
             </div>
    }
  };

  const classes = useStyles();

  return (
    <>
    <form>
      <div>
        {getStepContent(activeStep)}
      </div>
      <div>
      <Box style= {{ height: 100,
        display: "flex",
        padding: 4,
        justifyContent: "space-between",
        alignItems: "center"}}
        >
        {checkAll(label_grouping[activeStep].fields) && !submitting ?
         <Button
           pr={2}
           variant="contained"
           style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7", flex: 1}}
           onClick={activeStep === label_grouping.length - 1 ? handleSubmit : handleNext}
         >
           Get Free Trial
         </Button>
         :
          <Button
           pr={2}
           variant="outlined"
           disabled
           style={{flex: 1}}
           onClick={activeStep === label_grouping.length - 1 ? handleSubmit : handleNext}
          >
           {activeStep === label_grouping.length - 1 ? 'Get Free Trial' : 'Next'}
          </Button>}
         </Box>
      </div>
    </form>
    </>
  );
};

export default ContactForm;